export default "<div>\n  <button class=\"btn ant-btn-sm\" (click)=\"redirect()\">Submit </button>\n</div>\n"